import { routes } from 'appConstants';

export const mediaCategoryRoutes: {[key: number]: {
  label: string,
  to: string,
}} = {
  3: {
    label: routes.media.news.label,
    to: routes.media.news.root,
  },
  // 21: {
  //   label: routes.media.history.label,
  //   to: routes.media.history.root,
  // },
  // 22: {
  //   label: routes.media.interview.label,
  //   to: routes.media.interview.root,
  // },
  4: {
    label: routes.media.articles.label,
    to: routes.media.articles.root,
  },
  47: {
    label: routes.media.specProjects.label,
    to: routes.media.specProjects.root,
  },
  46: {
    label: routes.media.techTours.label,
    to: routes.media.techTours.root,
  },
  500: {
    label: routes.media.videoAlbums.label,
    to: routes.media.videoAlbums.root,
  },
};

export const DefaultLang:string = 'ru';

const setDefaultLang: () => string = () => {
  const isDefaultLang:boolean = navigator.language.toLowerCase().indexOf(DefaultLang) >= 0;
  const ClientLang = isDefaultLang ? DefaultLang : 'en';
  localStorage.setItem('siteLocale', ClientLang);
  return ClientLang;
};

export const ClientLang:string = localStorage.getItem('siteLocale') || setDefaultLang();

export const isProd:boolean = window.location.href.includes('https://prom.moscow/');
export const isLocalTest:boolean = window.location.href.includes('http://localhost:300');

const LAYOUT_MOCK_KEY = 'useLayoutMock';

try {
  const layoutParam = new URLSearchParams(window.location.search).get('layout');
  if (layoutParam === 'mock') {
    localStorage.setItem(LAYOUT_MOCK_KEY, 'true');
  } else if (layoutParam === 'live') {
    localStorage.removeItem(LAYOUT_MOCK_KEY);
  }
} catch (err) {
  // ignore
}

export const isLayoutMock = (): boolean => (
  !isProd && localStorage.getItem(LAYOUT_MOCK_KEY) === 'true'
);

export const isDemoNewsSlug = (id?: string): boolean => (
  Boolean(id) && (id === 'demo-news' || String(id).indexOf('demo-news-') === 0)
);

export const isDemoEventSlug = (id?: string): boolean => (
  Boolean(id) && (id === 'demo-event' || String(id).indexOf('demo-event-') === 0)
);

export const toggleLayoutMock = (): void => {
  if (isLayoutMock()) {
    localStorage.removeItem(LAYOUT_MOCK_KEY);
  } else {
    localStorage.setItem(LAYOUT_MOCK_KEY, 'true');
  }
  window.location.reload();
};

export const showLoginOnProd = true;

export const envSwitch: () => string = () => {
  if (isLocalTest) {
    if (localStorage.getItem('useProdEnv') === 'true') {
      return 'https://prom.moscow/';
    }
    return '';
  }
  return process.env.REACT_APP_API_URL as string;
};

export const setPageMeta = (title?:string, descr?:string) => {
  const SiteName:string = ClientLang === DefaultLang ? 'МОСПРОМ' : 'MOSPROM';
  document.title = `${title || SiteName}`;
  // @ts-ignore: Unreachable code error
  document.getElementsByName('description')[0].content = descr || 'Центр поддержки и развития экспорта "Моспром"'.concat(title);
};

export const addPageMeta = (title:string) => {
  document.title = `${document.title} ${title ? ' - '.concat(title) : ''}`;
};
